// extracted by mini-css-extract-plugin
export default {"modal":"loader_modal__lrj92","wrapper":"loader_wrapper__6Mx5c"};